import { Service } from './service.model';
import { Image } from './image.model';
import { Specification } from './specification.model';

export enum OfferType {
  REPLACEMENT = 'REPLACEMENT',
  UPGRADE = 'UPGRADE',
}

export enum OffersType {
  BESPOKE = 'Bespoke',
  STANDARD = 'Standard',
}

export interface ReplacementOffer {
  offer_type: OfferType;
  display_order: number;
  upgrade_fee: number;
  rrp?: number;
  article_id?: number;
  appliance_category?: string;
  short_description: string;
  long_description: string;
  selected?: boolean;
  supplier_name?: string;
  supplier_id?: number;
  cat_num: string;
  make?: string;
  model?: string;
  colour?: string;
  item_code?: string;
  manuf_code?: string;
  warranty?: number;
  services?: Service[];
  summary_specs?: string[];
  images: Image[];
  key_features?: Specification[];
  compare_specs: Specification[];
  detailed_specs?: Specification[];
  uniqueId?: string;
}

export const ReplacementOffer = undefined;
